import(/* webpackMode: "eager" */ "/tmp/8de38e4a1419f75/src/app/chat/page.tsx");
